export default __webpack_public_path__ + "static/media/Registro.6f758629.gif";